import { useTranslation } from 'react-i18next'
import { type StepWizardChildProps } from 'react-step-wizard'

import { useGetVerifyMyAgeUrl } from 'api/verification'
import { useSettingsCheck } from 'api/verification/useSettingsCheck/useSettingsCheck'
import { addToast } from 'components/Toast/Toast'
import {
    VerificationFooter,
    VerificationUplaodImagesContent
} from 'components-ref/organisms/verification'
import { useUserProfile } from 'store'

import { VerificationContainer } from '../VerificationCountry/VerificationCountry'

export function VerificationVerifyMyIdentity({
    currentStep,
    previousStep,
    nextStep,
}: Partial<StepWizardChildProps>) {
    const userData = useUserProfile()
    const { t } = useTranslation()
    const getVMAUrl = useGetVerifyMyAgeUrl()
    const { data: settingsValue } = useSettingsCheck()

    const verifyMyAge = async () => {
        if (getVMAUrl.isLoading) {
            return
        }

        try {
            const url = await getVMAUrl.mutateAsync()
            window.location.href = url
        } catch (_err) {
            addToast(
                'error',
                t('error:errorSomethingWentWrong'),
                undefined,
                true
            )
        }
    }
    

    return (
        <VerificationContainer>
            <VerificationUplaodImagesContent hideUpload={true} />
            <VerificationFooter
                nextStepText={t('verify')}
                currentStep={currentStep}
                previousStep={previousStep}
                nextStep={settingsValue === 1 ? verifyMyAge : nextStep}
                nextDisabled={!userData?.cover?.url || !userData?.avatar?.url}
            />
        </VerificationContainer>
    )
}
